export const END_CALL = 'events/END_CALL';

/**
 * @return {{type: string}}
 */
export const endCall = () => ({ type: END_CALL });
